import { makeApolloClient, logError } from '../util';
import { CLIENT_ATTENDEES, EVENT_ATTENDEES } from 'queries/attendee';
export const SET_ATTENDEES = 'SET_ATTENDEES';
export const CLEAR_ATTENDEES = 'CLEAR_ATTENDEES_DATA';

const setAttendees = (attendees, from) => ({
	type: SET_ATTENDEES,
	attendees,
	from,
});

export const clearAttendees = from => ({
	type: CLEAR_ATTENDEES,
	from,
});

const EMPTY_PAGE = { nodes: [], page_info: { has_next_page: false, total_count: 0 } };

// isCurrent lets the caller drop a response that a newer request has replaced.
export const thunkFetchEventAttendees = (
	gqlParams,
	from,
	{ isCurrent = () => true, onError } = {}
) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventAttendees } = await client.request(EVENT_ATTENDEES, gqlParams);
		if (isCurrent()) dispatch(setAttendees(eventAttendees, from));
		return eventAttendees.nodes;
	} catch (error) {
		logError(error, 'attendees.actions.thunkFetchEventAttendees');
		if (!isCurrent()) return;
		dispatch(setAttendees(EMPTY_PAGE, from));
		if (onError) onError(error);
	}
};

export const thunkFetchClientAttendees = (gqlParams, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { client_id, search_term, items_per_page, offset } = gqlParams;
		const { clientAttendees } = await client.request(CLIENT_ATTENDEES, {
			client_id,
			search_term,
			items_per_page,
			offset,
		});
		dispatch(setAttendees(clientAttendees, from));
	} catch (error) {
		logError(error, 'attendees.actions.thunkFetchClientAttendees');
	}
};
